export function getSystemTheme() {
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark'
  }
  return 'light'
}

export function applyThemeToDocument(theme) {
  document.documentElement.setAttribute('data-theme', theme)
}

export function onSystemThemeChange(callback) {
  if (window.matchMedia) {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    mediaQuery.addEventListener('change', e => {
      callback(e.matches ? 'dark' : 'light')
    })
  }
}
